import React, { useState, useEffect } from "react"
import Navbar from "../partials/navbar"
import Header from "../partials/header"
import api from "../api/config"
import { classNames } from 'primereact/utils'
import { FilterMatchMode, FilterOperator } from 'primereact/api'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { InputText } from 'primereact/inputtext'
import { Dropdown } from 'primereact/dropdown'
import { MultiSelect } from 'primereact/multiselect'
import { Tag } from 'primereact/tag'
import { TriStateCheckbox } from 'primereact/tristatecheckbox'
import { PrimeReactProvider, PrimeReactContext } from 'primereact/api'
//theme
import "primereact/resources/themes/lara-light-indigo/theme.css"

import { useNavigate } from 'react-router-dom'
import "primereact/resources/themes/lara-light-indigo/theme.css"               

const Users = (props) => {
  const navigate = useNavigate();  // <-- Change this
    const [members, setMembers] = useState([])
    

    useEffect(() => {
        api.get('/api/users')
            .then(response => response.data)
            .then(data => setMembers(data))
            .catch(error => console.error('Error fetching users:', error));
    }, []);

    return (
        <div className="nk-app-root">
            <div className="nk-main">
                <Header />
                <div className="nk-wrap">
                    <Navbar />
                    <div className="nk-content nk-content-fluid">
                        <div className="container-xl wide-xl">
                            <div className="nk-content-body">
                                <div className="components-preview wide-xl mx-auto">
                                    <div className="nk-block-head nk-block-head-lg wide-sm">
                                        <div className="nk-block-head-content">
                                            <div className="nk-block-head-sub">
                                                <a className="back-to" href="/dashboard">
                                                    <em className="icon ni ni-arrow-left" />
                                                    <span>Home</span>
                                                </a>
                                            </div>
                                            <h2 className="nk-block-title fw-normal">
                                                Campaign members
                                            </h2>
                                            <div className="nk-block-des">
                                                <p className="lead">
                                                    Customers who have joined Christmas campaign
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="nk-block nk-block-lg">
                                        <div className="card card-preview">
                                            <div className="card-inner">
                                                <PrimeReactProvider>
                                                    <DataTable 
                                                        value={members} 
                                                        paginator 
                                                        rows={10} 
                                                        dataKey="id" 
                                                        reorderableRows={true}
                                                        onRowClick={(e) => navigate(`/users/${e.data.phone}`)}
                                                    >
                                                        <Column field="customer" header="Name" filter filterPlaceholder="Search by name" style={{ minWidth: '12rem' }}  />
                                                        <Column field="email" header="Email address" filter filterPlaceholder="Search by email" style={{ minWidth: '15rem' }}  />
                                                        <Column field="phone" header="Mobile Number" filter filterPlaceholder="Search by mobile number" style={{ minWidth: '12rem' }} />
                                                    </DataTable>
                                                </PrimeReactProvider>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="nk-footer">
                        <div className="container-xl wide-xl">
                            <div className="nk-footer-wrap">
                                <div className="nk-footer-copyright">
                                    © 2023 Westgate Shopping Mall
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Users
